<div fxLayout="column">
    <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
    <div *ngIf="isBrowserIE; else verifyFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="verifyFlexColumnTemplate"></ng-container>
    </div>
</div>

<ng-template #verifyFlexColumnTemplate>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
    <div fxFlex="100%" fxLayout="column" fxLayoutGap.lt-md="10px" class="large-paragraph-spacing"
        [ngClass]="{ 'ie-display': isBrowserIE }">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else verifyMessagesFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="verifyMessagesFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex="100%" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="10px">
        <div *ngIf="isBrowserIE && media.isActive('lt-md'); else verifyMainFlexColumnTemplate">
            <ng-container *ngTemplateOutlet="verifyMainFlexColumnTemplate"></ng-container>
        </div>
    </div>
    <div fxFlex.lt-md="10px" fxFlex.gt-sm="25px">&nbsp;</div>
</ng-template>

<ng-template #verifyMessagesFlexColumnTemplate>
    <div fxFlex="5%" fxHide.lt-md></div>
    <div fxFlex="90%" fxLayoutAlign="center center" ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
        class="large-paragraph-pre-spacing" *ngIf="showInstructionMessagesSpinner">
        <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div fxFlex="90%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px" class="large-paragraph-pre-spacing"
        *ngIf="!showInstructionMessagesSpinner && this.instructionMessageList.length > 0">
        <div ngStyle.gt-sm="padding-left: 24px; padding-right: 24px"
            ngStyle.lt-md="padding-left: 8px; padding-right: 8px"
            class="extra-large-display-text normal-paragraph-spacing center-text" [ngClass]="getMessageCssClass(item)"
            *ngFor="let item of this.instructionMessageList">
            {{ item.messageText }}
        </div>
    </div>
    <div fxFlex="5%" fxHide.lt-md></div>
</ng-template>

<ng-template #verifyMainFlexColumnTemplate>
    <div fxFlex="50%" fxHide.lt-md></div>
    <div fxFlex="500px" fxFlex.lt-md="100%" ngStyle.lt-md="padding-left: 8px; padding-right: 8px;">
        <div class="display-text normal-paragraph-spacing">
            <mat-card>
                <mat-card-content>
                    <div fxLayout="column">
                        <div *ngIf="isBrowserIE; else multifactorVerifyFlexColumnTemplate">
                            <ng-container *ngTemplateOutlet="multifactorVerifyFlexColumnTemplate"></ng-container>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div fxFlex="50%" fxHide.lt-md></div>
</ng-template>

<ng-template #multifactorVerifyFlexColumnTemplate>
    <div fxLayout="column" *ngIf="showVerificationFormView">
        <div class="display-text primary-dark-color-important">
            <b><span i18n="@@login-one-time.form.title">login-one-time.form.title</span></b>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showActivitySpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
        </div>
        <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
        <div class="display-text">
            <form [formGroup]="multifactorVerifyForm">
                <div fxLayout="column">
                    <div fxLayout="row" class="display-text normal-paragraph-spacing">
                        <b><p i18n="@@multifactor-verify.form.pre-message.1">multifactor-verify.form.pre-message.1</p></b>
                    </div>
                    <div fxLayout="row" class="display-text normal-paragraph-spacing">
                        <b><p i18n="@@multifactor-verify.form.pre-message.2">multifactor-verify.form.pre-message.2</p></b>
                    </div>
                    <div fxLayout="row" class="display-text normal-paragraph-spacing">
                        <p>If the email address listed below is incorrect or marked invalid,<br/>please call us at <b>{{
                            formatPhoneNumber(companyInformation.customerServiceNumber)
                          }} </b>to update it.</p>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
                        <div class="display-text">E-mail : {{ homeEmail }}</div>
                    </div>
                    <div fxLayout="row" class="display-text normal-paragraph-spacing warning-color" *ngIf="!isEmailValid()">
                        <p>The email address listed above is invalid. Please contact us at the above listed number to update your email address.</p>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text">
                        <mat-form-field ngStyle.gt-sm="width: 80%" fxFlex.lt-md="90%">
                            <input matInput i18n-placeholder="@@login-one-time.form.temporary-password.placeholder"
                                placeholder="login-one-time.form.temporary-password.placeholder" type="text"
                                [formControl]="verificationCodeFormControl" autocomplete="off"
                                [maxlength]="fieldValidations.userRegistration.temporaryPasswordMaxLength" 
                                [attr.disabled]="!isEmailValid()"
                                required />
                            <mat-hint align="end"
                                i18n="@@login-one-time.form.hint.temporary-password">login-one-time.form.hint.temporary-password</mat-hint>
                            <mat-error *ngIf="verificationCodeFormControl.hasError('required')"
                                i18n="@@login-one-time.form.error.required">login-one-time.form.error.required</mat-error>
                        </mat-form-field>
                    </div>
                    <div fxLayout="row"
                        class="display-text warning-color normal-paragraph-spacing normal-paragraph-pre-spacing"
                        *ngIf="showTemporaryPasswordError">
                        <b><span
                                i18n="@@multifactor-verify.temporary-password-message.error.1">multifactor-verify.temporary-password-message.error.1</span></b>
                    </div>

                    <div fxLayout="row"
                        class="display-text warning-color normal-paragraph-spacing" *ngIf="showTemporaryPasswordError">
                        <b><span
                                i18n="@@multifactor-verify.temporary-password-message.error.2">multifactor-verify.temporary-password-message.error.2</span></b>
                    </div>

                    <div fxLayout="row"
                        class="display-text warning-color normal-paragraph-spacing normal-paragraph-pre-spacing"
                        *ngIf="showExpiredVerificationCodeError">
                        <b><span
                                i18n="@@login-one-time.expired-otp-code-message.error.1">login-one-time.expired-otp-code-message.error.1</span></b>
                    </div>
                    <div fxLayout="row"
                        class="display-text warning-color normal-paragraph-spacing"
                        *ngIf="showExpiredVerificationCodeError">
                        <b><span
                                i18n="@@login-one-time.expired-otp-code-message.error.2">login-one-time.expired-otp-code-message.error.2</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center"
                        class="display-text normal-paragraph-spacing normal-paragraph-pre-spacing">
                        <re-captcha formControlName="recaptchaFormControl" siteKey="{{ recaptchaSiteKey }}" required ></re-captcha>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
                        <button mat-flat-button color="primary" type="button" (click)="checkVerificationCode()"
                            i18n="@@multifactor-verify.verify.label" [attr.disabled]="!isEmailValid()">
                            multifactor-verify.verify.label
                        </button>
                        &nbsp;&nbsp;
                        <button mat-stroked-button color="primary" (click)="sendVerificationCode(true)" type="button" [attr.disabled]="!isEmailValid()"
                            i18n="@@multifactor-verify.resend.label">
                            multifactor-verify.resend.label
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div fxLayout="column" *ngIf="showVerificationGracePeriodView">
        <div class="display-text primary-dark-color-important">
            <b><span i18n="@@multifactor-verify.grace.title">multifactor-verify.grace.title</span></b>
        </div>
        <div fxLayout="row" fxLayoutAlign="center center" class="display-text" *ngIf="showActivitySpinner">
            <mat-spinner color="accent" diameter="32"></mat-spinner>
          </div>
        <div class="border-bottom-blue" style="margin-top: 16px; margin-bottom: 16px;"></div>
        <div class="display-text">
                <div fxLayout="column">
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
                        <b><span i18n="@@multifactor-verify.grace.message">multifactor-verify.grace.message</span></b>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
                        <p><span>If the email address listed below is incorrect or marked invalid, please go to the <a href="/Profile" (click)="goToProfile()">Profile</a> screen to update it before proceeding to enroll.</span></p>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
                        <div class="display-text">E-mail : {{ homeEmail }}</div>
                    </div>
                    <div fxLayout="row" class="display-text normal-paragraph-spacing warning-color" *ngIf="!isEmailValid()">
                        <p>The email address listed above is invalid. Please contact us at <b>{{ formatPhoneNumber(companyInformation.customerServiceNumber) }}</b> to update your email address.</p>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center center" class="display-text normal-paragraph-spacing">
                        <button mat-flat-button color="primary" i18n="@@multifactor-verify.grace.skip.label" (click)="skip()">
                            multifactor-verify.grace.skip.label
                        </button>
                        &nbsp;&nbsp;
                        <button mat-stroked-button color="primary" i18n="@@multifactor-verify.grace.enroll.label" (click)="enroll()" [attr.disabled]="!isEmailValid()">
                            multifactor-verify.grace.enroll.label
                        </button>
                    </div>
                </div>
            </div>
    </div>
</ng-template>
